import React, { Component } from "react";
import OCPEntry from "./OCPEntry";

class ChallanEntry extends Component {
  render() {
    return (
      <OCPEntry
        module="Challan"
        Type="Challan"
        No="Challan"
        itemEntryPage="ChallanItemEntry"
      />
    );
  }
}

export default ChallanEntry;
